/* eslint-disable
    eqeqeq,
    */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { ActionView, events } from 'app/scripts/views/action/ActionView';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { AutoInsertionView } from 'app/scripts/views/internal/autocomplete/AutoInsertionView';
import { AttachLinksView as CardAttachLinksView } from 'app/scripts/views/card/AttachLinksView';
import { CompleterUtil } from 'app/scripts/views/internal/autocomplete/CompleterUtil';
import Confirm from 'app/scripts/views/lib/confirm';
import { getKey, isForceSubmitEvent, Key } from '@trello/keybindings';
import Layout from 'app/scripts/views/lib/layout';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import AttachmentViewer from 'app/scripts/views/internal/attachment-viewer';
import { TrelloStorage } from '@trello/storage';
import TFM from 'app/scripts/lib/markdown/tfm';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import _ from 'underscore';
import f from 'effing';
import { linksFromMarkdown } from 'app/scripts/lib/util/text/links-from-markdown';
import LengthCheckingMixin from 'app/scripts/views/internal/disable-submit-if-length-too-long';
import { applyMarkdownShortcuts } from 'app/scripts/views/lib/markdown-transform';
import { markdownTracker } from 'app/scripts/lib/markdown/markdownTracker';

class CommentActionView extends ActionView {
  static initClass() {
    this.prototype.events = {
      ...events,
      'click .js-confirm-delete-action': 'confirmDeleteAction',
      'click .js-edit-action': 'editAction',
      'click .js-discard-comment-edits': 'cancelEdit',
      'click .js-save-edit': 'saveEdit',
      'keyup .js-text': 'keyAutoMention',
      'keydown .js-text': 'keydownJsText',
      'input .js-text': 'checkLength',
      'mutated .js-text': 'mutatedEvent',

      'click .js-comment-add-attachment': 'commentAddAttachment',
      'click .js-comment-mention-member': 'commentMentionMember',
      'click .js-comment-add-emoji': 'commentAddEmoji',
      'click .js-comment-add-card': 'commentAddCard',
      'click .js-attach-link': 'attachLink',
    };
  }

  constructor(options) {
    super(options);
  }

  initialize() {
    super.initialize(...arguments);
    return $(window).on(
      `beforeunload.CommentActionView-${this.model.cid}`,
      f(this, 'saveDraft'),
    );
  }

  remove() {
    this.saveDraft();
    $(window).off(`.CommentActionView-${this.model.cid}`);
    super.remove(...arguments);
  }

  mutatedEvent(e) {
    this.checkLength(e);
    this.getTextInput().trigger('autosize.resize');
  }

  potentialAttachments() {
    const card = this.model.getCard();
    return _.filter(
      linksFromMarkdown(this.model.get('data').text, TFM.comments),
      function ({ url }) {
        // Don't include URLs that are not allowed by the enterprise
        if (card.attachmentUrlRestricted(url)) {
          return false;
        }

        // Don't include things that have already been attached
        return !card.attachmentList.any(
          (attachment) => attachment.get('url') === url,
        );
      },
    );
  }

  getContext() {
    const data = super.getContext(...arguments);
    const card = this.model.getCard();
    // It's possible that comment is for a card that isn't currently cached, in
    // which case we can't attach a link to it
    data.canAttachLink =
      card != null && card.editable() && this.potentialAttachments().length > 0;
    return data;
  }

  confirmDeleteAction(e) {
    stopPropagationAndPreventDefault(e);

    Confirm.toggle('delete comment', {
      elem: $(e.target).closest('.js-confirm-delete-action')[0],
      model: this.model,
      confirmBtnClass: 'nch-button nch-button--danger',
      fxConfirm: () => {
        const traceId = Analytics.startTask({
          taskName: 'delete-comment',
          source: 'cardDetailScreen',
        });
        return this.model.destroyWithTracing(
          {
            traceId,
          },
          tracingCallback(
            {
              taskName: 'delete-comment',
              traceId,
              source: 'cardDetailScreen',
            },
            (err) => {
              if (!err) {
                Analytics.sendTrackEvent({
                  action: 'deleted',
                  actionSubject: 'comment',
                  source: 'cardDetailScreen',
                  attributes: {
                    taskId: traceId,
                  },
                });
              }
            },
          ),
        );
      },
    });
  }

  getTextInput() {
    return this.$('.js-text');
  }

  getMentionTarget() {
    return this.$('.js-comment-mention-member:visible')[0];
  }

  getEmojiTarget() {
    return this.$('.js-comment-add-emoji:visible')[0];
  }

  editAction(e) {
    stopPropagationAndPreventDefault(e);
    if (this.$el.hasClass('is-editing')) {
      return;
    }
    this.$el.addClass('is-editing');
    this.$('textarea').focus().select();
    return this.openEditView();
  }

  openEditView() {
    this.$('.js-text').attr('placeholder', '').autosize({ append: false });
  }

  keydownJsText(e) {
    applyMarkdownShortcuts(e);

    if (isForceSubmitEvent(e)) {
      return this.saveEdit(e);
    } else if (getKey(e) === Key.Escape) {
      stopPropagationAndPreventDefault(e);

      if (AttachmentViewer.isActive()) {
        AttachmentViewer.clear();
        return;
      }

      return this.cancelEdit();
    } else {
      return this.checkInsert(e);
    }
  }

  saveEdit(e) {
    if (
      !(
        e.type !== 'keypress' ||
        // If they pressed ctrl+enter, then that's always a submit
        isForceSubmitEvent(e) ||
        // If they pressed enter, and they aren't on a multi-line textarea, that's also a submit
        (getKey(e) === Key.Enter &&
          (!$(e.target).is('textarea') ||
            $(e.currentTarget).hasClass('single-line')))
      )
    ) {
      return;
    }

    const traceId = Analytics.startTask({
      taskName: 'edit-comment',
      source: 'cardDetailScreen',
    });

    stopPropagationAndPreventDefault(e);
    const newValue = this.$('.js-text').val();

    this.$('.js-spinner').show();
    this.$('.js-hide-on-sending').hide();

    this.$('.current-comment').text(newValue);
    Layout.cancelEdit(this.$el);
    this.discardDraft();

    // So that we don't have to wait for the roundtrip to display the
    // new text, which would be very scary for users.
    this.model.get('display').entities.comment.text = newValue;
    const data = {
      text: newValue,
      traceId,
    };
    this.model.update(
      data,
      tracingCallback(
        {
          taskName: 'edit-comment',
          source: 'cardDetailScreen',
          traceId,
        },
        (err, response) => {
          if (!err && response) {
            Analytics.sendTrackEvent({
              action: 'updated',
              actionSubject: 'comment',
              source: 'cardDetailScreen',
              containers: {
                card: { id: response.data?.card?.id },
                board: { id: response.data?.board?.id },
                list: { id: response.data?.list?.id },
              },
              attributes: {
                taskId: traceId,
              },
            });
          }
        },
      ),
    );

    this.$('.js-text').trigger('autosize.destroy');

    PopOver.hide();
    markdownTracker(newValue, 'comments');
  }

  showError(e) {}

  cancelEdit() {
    const prevComment = this.model.get('data').text;
    this.$('.js-text').val(prevComment);
    Layout.cancelEdit(this.$el);
    this.discardDraft();
    this.$('.js-text').trigger('autosize.destroy');
  }

  getCard() {
    return this.model.getCard();
  }

  attachLink(e) {
    stopPropagationAndPreventDefault(e);

    const links = this.potentialAttachments();
    return PopOver.toggle({
      elem: $(e.currentTarget),
      view: new CardAttachLinksView({
        model: this.getCard(),
        modelCache: this.modelCache,
        links,
      }),
    });
  }

  render() {
    super.render(...arguments);
    this.recallDraft();

    return this;
  }

  _draftKey() {
    return `draft_${this.model.id}_edit`;
  }

  recallDraft() {
    const draftText = TrelloStorage.get(this._draftKey());
    if (draftText) {
      this.getTextInput().val(draftText);
      return this.$el.find('.edits-warning').show();
    }
  }

  saveDraft() {
    if (this.$el.hasClass('is-editing')) {
      const text = this.getTextInput().val();

      if (text && text !== this.model.get('data').text) {
        TrelloStorage.set(this._draftKey(), text);
        this.$el.find('.edits-warning').show();
      } else {
        this.discardDraft();
      }
    }
  }

  discardDraft() {
    TrelloStorage.unset(this._draftKey());
    return this.$el.find('.edits-warning').hide();
  }
}
CommentActionView.initClass();

_.extend(
  CommentActionView.prototype,
  AutoInsertionView,
  CompleterUtil,
  LengthCheckingMixin,
);

export { CommentActionView };
